/* global COMMITHASH, APPCUES_ENV */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { checkLoginStatus } from "actions/firebase";
import Loader from "components/Common/Loader";
import WebRoutes from "components/App/web-routes";
import { configureErrorReporting } from "helpers/error-reporting";
import { selectFirebaseHasCheckedLogin } from "reducers/firebase";
import loadFonts from "fonts";

import "components/App/style.scss";

export const App = ({ loaded = false, onLoad }) => {
  useEffect(() => {
    if (onLoad) {
      onLoad();
    }
  }, [onLoad]);

  if (!loaded) {
    return <Loader />;
  }

  return <WebRoutes />;
};

App.propTypes = {
  loaded: PropTypes.bool,
  onLoad: PropTypes.func
};

const mapStateToProps = state => ({
  loaded: selectFirebaseHasCheckedLogin(state)
});

const mapDispatchToProps = {
  onLoad: () => {
    loadFonts();
    configureErrorReporting(COMMITHASH, APPCUES_ENV);
    return checkLoginStatus();
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
